import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { COMPANY } from "../data/mock";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 left-5 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${COMPANY.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
        className="w-12 h-12 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-black/40 hover:scale-105 transition-transform"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
      <a
        href={`tel:${COMPANY.phoneRaw}`}
        aria-label="Anrufen"
        className="w-12 h-12 rounded-full bg-[#1f5fe0] flex items-center justify-center shadow-lg shadow-black/40 hover:scale-105 transition-transform"
      >
        <Phone className="w-6 h-6 text-white" />
      </a>
    </div>
  );
}
